import type { Accept } from "react-dropzone";

/**
 * Accepted file MIME types for chat file uploads.
 * Supports PDF, Excel (.xlsx), and Word (.docx) files.
 *
 * This constant is shared across multiple file upload components to ensure
 * consistent file type support throughout the application.
 */
export const CHAT_FILE_ACCEPT: Accept = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
};

/**
 * Supported file MIME types for chat file uploads.
 * Supports PDF, Excel (.xlsx), and Word (.docx) files.
 *
 * This constant is shared across multiple file upload components to ensure
 * consistent file type support throughout the application.
 */
export const CHAT_FILE_SUPPORTED_MIME_TYPES = new Set(Object.keys(CHAT_FILE_ACCEPT));

/**
 * Maximum file size for chat file uploads (25MB).
 */
export const CHAT_FILE_MAX_SIZE = 25 * 1024 * 1024;
